<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const emailAddress = 'care@revolugo.com'
const phoneNumber = '+33 1 80 06 62 88'
</script>

<template>
  <div class="flex flex-col gap-1">
    <h6 class="text-xl font-medium text-neutral-950">
      {{ t('title') }}
    </h6>
    <p class="font-normal text-neutral-400">
      {{ t('description') }}
    </p>
    <ul class="list-none">
      <li class="flex gap-1 items-center">
        <i class="icon-[ph--envelope] text-lg" />
        <a
          class="underline"
          :href="'mailto:' + emailAddress"
        >
          {{ emailAddress }}
        </a>
      </li>
      <li class="flex gap-1 items-center">
        <i class="icon-[ph--phone] text-lg" />
        <a
          class="underline"
          :href="'tel:' + phoneNumber"
        >
          {{ phoneNumber }}
        </a>
      </li>
    </ul>
  </div>
</template>

<i18n lang="json" src="./RContactUs.i18n.json"></i18n>
